import type { StatusMap } from '../types/show';

interface Tier {
  min: number;
  title: string;
  blurb: string;
}

const tiers: Tier[] = [
  { min: 100, title: 'You have seen everything', blurb: 'Every single one. Please go outside.' },
  { min: 85, title: 'Walking streaming library', blurb: 'Critics call you for recommendations.' },
  { min: 65, title: 'Peak TV scholar', blurb: 'You have opinions about season finales.' },
  { min: 45, title: 'Certified couch critic', blurb: 'Your remote has a groove worn in it.' },
  { min: 25, title: 'Prestige TV regular', blurb: 'Sunday nights are spoken for.' },
  { min: 10, title: 'Weekend binger', blurb: 'A solid start. The queue awaits.' },
  { min: 1, title: 'Casual viewer', blurb: 'Plenty of great TV still ahead of you.' },
  { min: 0, title: 'Blank slate', blurb: 'Tap the shows you have seen to begin.' },
];

export function getTier(seen: number): Tier {
  return tiers.find((t) => seen >= t.min) ?? tiers[tiers.length - 1];
}

export function buildShareText(statuses: StatusMap, total: number, seen: number): string {
  const tier = getTier(seen);
  const rows: string[] = [];
  for (let r = 0; r < total / 10; r++) {
    let row = '';
    for (let c = 1; c <= 10; c++) {
      const status = statuses[r * 10 + c];
      row += status === 'seen' ? '🟩' : status === 'want' ? '🟨' : '⬜';
    }
    rows.push(row);
  }
  const url = typeof window !== 'undefined' ? window.location.href : '';
  return `I've seen ${seen}/${total} of the NYT's 100 Best TV Shows of the 21st Century — ${tier.title}.\n\n${rows.join('\n')}\n\nHow many have you seen? ${url}`;
}
